.bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  height: 52px;
  padding-inline: max(var(--space-2), env(safe-area-inset-left)) max(var(--space-3), env(safe-area-inset-right));
  background: var(--bg);
  border-bottom: var(--hairline) solid transparent;
}

.scrolled {
  border-bottom-color: var(--separator);
}

.icon {
  display: inline-grid;
  flex: none;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--label-2);
  cursor: pointer;
}

.icon:hover {
  background: var(--fill);
  color: var(--label);
}

.help {
  font: var(--text-headline);
}

.mark {
  display: inline-grid;
  flex: none;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-control);
  color: var(--ink);
}

.workspaceBox {
  position: relative;
  flex: none;
}

.workspace {
  flex: none;
  padding: var(--space-1) var(--space-2);
  border: 0;
  border-radius: var(--radius-control);
  background: transparent;
  font: var(--text-headline);
  letter-spacing: var(--tracking-headline);
  color: var(--label);
  white-space: nowrap;
}

button.workspace {
  cursor: pointer;
}

button.workspace:hover {
  background: var(--fill);
}

.caret {
  color: var(--label-3);
}

.workspaceMenu {
  position: absolute;
  top: calc(100% + var(--space-1));
  left: 0;
  z-index: 30;
}

.menuItem {
  display: block;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-control);
  color: var(--label);
  text-decoration: none;
}

.menuItem:hover,
.menuItem:focus-visible {
  background: var(--fill);
}

.menuItem[aria-current="page"] {
  font: var(--text-headline);
}

.search {
  position: relative;
  flex: 0 1 380px;
  min-width: 0;
  margin-left: var(--space-2);
}

.searchInput {
  width: 100%;
  height: 34px;
  padding: 0 var(--space-8) 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-control);
  background: var(--fill);
  color: var(--label);
  font: var(--text-callout);
  appearance: none;
}

.searchInput::placeholder {
  color: var(--label-3);
}

.searchInput::-webkit-search-cancel-button {
  display: none;
}

.searchKey {
  position: absolute;
  top: 50%;
  right: var(--space-2);
  transform: translateY(-50%);
  pointer-events: none;
}

.results {
  position: absolute;
  top: calc(100% + var(--space-1));
  left: 0;
  z-index: 30;
  width: min(440px, calc(100vw - 2 * var(--space-4)));
  max-height: min(70vh, 560px);
  overflow-y: auto;
  padding: var(--space-2);
  border: var(--hairline) solid var(--separator);
  border-radius: var(--radius-list);
  background: var(--card);
  box-shadow: var(--shadow-card);
}

.group {
  padding: var(--space-2) var(--space-2) var(--space-1);
  font: var(--text-caption-1);
  letter-spacing: var(--tracking-caption-1);
  color: var(--label-3);
  text-transform: uppercase;
}

.result {
  display: grid;
  gap: 2px;
  padding: var(--space-2);
  border-radius: var(--radius-control);
  color: var(--label);
  text-decoration: none;
}

.active {
  background: var(--fill);
}

.resultName {
  font: var(--text-callout);
}

.resultPath {
  font: var(--text-footnote);
  color: var(--label-3);
}

.nothing {
  padding: var(--space-3) var(--space-2);
  font: var(--text-callout);
  color: var(--label-2);
}

.end {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--space-1);
  margin-left: auto;
}

.end > p {
  position: absolute;
  top: 100%;
  right: var(--space-3);
  background: var(--bg);
  font: var(--text-caption-2);
  color: var(--label-2);
}

.fresh {
  margin-right: var(--space-2);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-control);
  font: var(--text-footnote);
  color: var(--label-2);
  text-decoration: none;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.fresh:hover {
  background: var(--fill);
}

.late {
  color: var(--warn-text);
}

.stopped {
  color: var(--neg-text);
}

.ask {
  flex: none;
  height: 34px;
  padding: 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-control);
  background: var(--fill);
  font: var(--text-subhead);
  color: var(--label);
  cursor: pointer;
}

.ask:hover {
  background: color-mix(in srgb, var(--fill) 80%, var(--ink));
}

.freshDot {
  display: none;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-control);
}

@media (max-width: 719px) {
  .workspace,
  .fresh,
  .searchKey,
  [data-tema],
  .help {
    display: none;
  }

  button.workspace {
    display: none;
  }

  .freshDot {
    display: inline-grid;
  }

  .search {
    flex: 1 1 auto;
    margin-left: 0;
  }

  .search:focus-within {
    position: absolute;
    inset: 9px var(--space-3);
    z-index: 25;
  }

  .searchInput {
    height: 34px;
    padding-right: var(--space-3);
    font-size: 16px;
  }

  .results {
    position: fixed;
    top: 52px;
    left: var(--space-2);
    width: calc(100vw - 2 * var(--space-2));
  }
}
